export default "__VITE_ASSET__c402e129__"